import React, { useState } from 'react';
import { Button, InputField } from '../../../components/uielements';
import {
  Heading,
  Main,
  SectionLeft,
  SignInSectionRight,
  FormWrapper,
  InputLabel,
  HelperText,
} from './login.style';
import { validateEmail, validatePassword } from '../../../helper/validationHelper';
import { useAuth } from '../../../hooks/useAuth';
import { LucideEye, LucideEyeOff } from 'lucide-react';
import { IconButton } from '../../pages/login/login.style';

const MapperAuthPage = () => {
  return (
    <Main>
      <SignIn />
    </Main>
  );
};

export default MapperAuthPage;

const SignIn = () => {
  const { login } = useAuth();
  const [errorMessages, setErrorMessages] = useState({
    email: '',
    password: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    setShowPassword((prevState) => !prevState);
  };

  const handleLogIn = async (event) => {
    try {
      setIsLoading(true);
      event.preventDefault();
      const data = new FormData(event.currentTarget);
      const isEmailValid = validateEmail(data.get('email'));
      const isPasswordValid = validatePassword(data.get('password'));

      const errors = {};

      if (!isEmailValid) {
        errors.email = 'Please enter a valid email address.';
      }
      if (!isPasswordValid) {
        errors.password = 'Please enter your password.';
      }

      if (Object.keys(errors).length > 0) {
        setErrorMessages(errors);
        setIsLoading(false);
        return;
      }

      await login(data.get('email'), data.get('password'), false, true);
    } catch (error) {
      setIsLoading(false);
      alert('Credentials not found. Please check your email and password.');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setErrorMessages((prev) => ({
      ...prev,
      [name]: '',
    }));

    if (name === 'email' && value && !validateEmail(value)) {
      setErrorMessages((prev) => ({
        ...prev,
        email: 'Please enter a valid email address.',
      }));
    }
    if (name === 'password' && value && !validatePassword(value)) {
      setErrorMessages((prev) => ({
        ...prev,
        password: 'Password must be at least 6 characters.',
      }));
    }
  };

  return (
    <Main>
      <SectionLeft onSubmit={handleLogIn}>
        <Heading>Mapper Log In</Heading>

        <FormWrapper>
          <InputLabel htmlFor="email">Email</InputLabel>
          <InputField
            type="email"
            id="email"
            placeholder="Email"
            name="email"
            onChange={handleInputChange}
          />
          {errorMessages.email && <HelperText>{errorMessages.email}</HelperText>}
        </FormWrapper>

        <FormWrapper style={{ marginBottom: '8px' }}>
          <InputLabel htmlFor="password">Password</InputLabel>
          <InputField
            id="password"
            placeholder="Password"
            name="password"
            onChange={handleInputChange}
            type={showPassword ? 'text' : 'password'}
          />{' '}
          <IconButton
            onClick={(e) => togglePasswordVisibility(e)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                togglePasswordVisibility(e);
              }
            }}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {showPassword ? (
              <LucideEye style={{ width: '19px', height: '19px', color: '#646465' }} />
            ) : (
              <LucideEyeOff style={{ width: '19px', height: '19px', color: '#646465' }} />
            )}
          </IconButton>
          {errorMessages.password && <HelperText>{errorMessages.password}</HelperText>}
        </FormWrapper>

        <Button type="submit" loading={isLoading}>
          Log In
        </Button>
      </SectionLeft>

      <SignInSectionRight />
    </Main>
  );
};
